import React from "react";
import "./style.scss";
import AppInfo from "./../../components/AppInfo";
import AppPermission from "./../../components/AppPermission";

export default function CreateAppStepTwo(props) {
  const { itemData } = props;

  return (
    <div className="step_two">
      <AppInfo itemData={itemData}></AppInfo>
      <AppPermission appKey={itemData.appKey}></AppPermission>
    </div>
  );
}
